// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-view[data-v-06051571]{height:100%;width:100%;display:flex;flex-grow:1;flex-direction:column;align-content:space-between}\n", ""]);
// Exports
module.exports = exports;
